import { Modal } from '../constants';
import { Modal as ModalType } from '../store/types';
import { IModalAction } from '../interfaces/actions';

export const open = (target: ModalType): IModalAction => ({ type: Modal.OPEN, target: target });
export const close = (target: ModalType): IModalAction => ({ type: Modal.CLOSE, target: target });


// WEBPACK FOOTER //
// ./src/actions/Modal.ts